import React, { useEffect } from 'react'
import { History, Location } from 'history'
import { match as Match } from 'react-router'
import { Row, Col } from 'styled-bootstrap-grid'
import { useSelector, useDispatch } from 'react-redux'
import _ from 'lodash'
import Wizard from '../../../components/Wizard'
import { AddHookName } from './AddHookName'
import { Layout, Box } from '../../../components/Page/Layout'
import { Page } from '../../../components/Page'
import { AddHookElements } from './AddHookElements'
import { HookActions } from '../../../features/hook/actions'
import { selectedHook } from '../../../features/hook/selectors'

type Props = {
  history: History
  location: Location<{ showInDashboard?: boolean } | undefined>
  match?: Match<{ hook_id: string }>
}

export const AddHookContainer = ({ history, match }: Props) => {
  const hookId = _.get(match, 'params.hookId')

  const hook = useSelector(selectedHook)
  const dispatch = useDispatch()

  useEffect(() => {
    if (hookId) {
      dispatch(HookActions.fetchHookInfo(hookId))
      dispatch(HookActions.updateHookValidation({ isValid: true }))
    } else {
      dispatch(
        HookActions.updateNewHook({
          name: '',
          title: 'base',
          button: 'CONTINUA',
          image: 'https://test2019.yooppe.com/images/popup_images/favorite.png',
          paymentTemplateId: '9b1a046c-4001-457e-8571-817eaf74bbc9'
        })
      )
    }
    return () => {
      dispatch(HookActions.resetNewHook())
      dispatch(HookActions.updateHookValidation({ isValid: false }))
    }
  }, [dispatch, hookId])

  const components: JSX.Element[] = []

  const addNewHook = () => {
    if (hook) {
      dispatch(HookActions.startSavingHook(hook))
    }
  }

  components.push(<AddHookName key="addhookname" close={history.goBack} />)
  components.push(<AddHookElements key="addhookelement" close={history.goBack} addHook={addNewHook} />)

  return (
    <Page>
      <Layout>
        <Row>
          <Col xl={8} lg={10} xlOffset={2} lgOffset={1} md={12}>
            <Box>
              <Wizard stepCount={components.length}>{components}</Wizard>
            </Box>
          </Col>
        </Row>
      </Layout>
    </Page>
  )
}
